export default __webpack_public_path__ + "static/media/Vision-Window-Door.47b97b8a.jpg";